module.exports = __webpack_public_path__ + "img/engagement.14e3caa2.svg";